import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

import Loader from '@hiredigital/ui/Loader';
import LoadingArea from '@hiredigital/ui/LoadingArea';

import Nav from '@components/Blog/Nav';
import LatestPost from '@components/Blog/LatestPost';
import Layout from '@components/Layout/Layout';

import { getStoriesByCategory } from '@helpers/posts';
import { withError } from '@helpers/error';

const BlogStories = dynamic(() => import('@components/PageComponents/BlogStories'), {
  loading: () => <LoadingArea height={500} />,
  ssr: false,
});
const Subscribe = dynamic(() => import('@components/Subscribe/Subscribe'), { ssr: false });

const Blog = ({ postData, metaData, params }) => {
  const [posts, setPosts] = useState(postData);
  const latestPost = postData?.[0]?.node;
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(false);
  const head = {
    title: `Insights | Hire Digital`,
  };

  useEffect(() => {
    setPosts([]);
    setMeta({});
    setPosts(() => [...postData]);
    setMeta(() => metaData);
  }, [postData]);

  const addMore = async () => {
    setLoading(true);
    const data = await getStoriesByCategory(meta.endCursor, params.category);
    setLoading(false);
    const newMeta = data?.pageInfo;
    const newPosts = data?.edges;

    setPosts(() => [...posts, ...newPosts]);
    setMeta(() => newMeta);
  };
  return (
    <Layout pageHead={head} variant={Layout.Variants.INSIGHTS} showHeaderBackground hasHero={false}>
      <Nav />
      {latestPost ? <LatestPost latestPost={latestPost} /> : ''}
      {posts?.length > 1 && (
        <BlogStories
          posts={posts}
          hasNext={meta?.hasNextPage}
          isLoading={loading}
          onLoadMore={addMore}
          start={1}
        />
      )}
      <Subscribe />
    </Layout>
  );
};

Blog.propTypes = {
  postData: PropTypes.array,
  metaData: PropTypes.object,
  params: PropTypes.object,
};

export default withError(Blog);

export const getStaticProps = async ({ params }) => {
  const data = await getStoriesByCategory('', params.category);

  const metaData = data?.pageInfo || {};
  const postData = data?.edges || [];
  // console.log(postData);
  if (!postData.length) {
    return {
      props: {
        error: {
          statusCode: 404,
          message: 'Page Not Found',
        },
      },
    };
  }

  return {
    props: { postData, metaData, params },
    revalidate: 500, // In seconds
  };
};

export const getStaticPaths = async () => {
  return {
    paths: [
      { params: { category: 'leaders' } },
      { params: { category: 'digital' } },
      { params: { category: 'storytelling' } },
      { params: { category: 'hiring-resources' } },
    ],
    fallback: true,
  };
};
